import { t } from '@reos/i18n';
/**
 * Krok K0b bod 7: `acceptance.missing` lidsky - pro radek NEEDS_REVIEW
 * v timeline zakazky a pro admin UI.
 *
 * Kody zustavaji strojove (`acceptance.ts` nezna zadny text, CLAUDE.md §1 bod 5);
 * teprve tady se z nich stava veta, a to pres i18n katalog s cs zdrojem a
 * povinnou en paritou. Cista funkce - zadna DB, zadny fastify kontext.
 */
export function formatAcceptanceMissing(missingItem, locale) {
    return t(`dd.acceptance.missing.${missingItem.code}`, {
        locale,
        values: {
            sectionId: missingItem.sectionId ?? '-',
            questionKey: missingItem.questionKey ?? '-',
            sourceId: missingItem.sourceId ?? '-',
            ref: missingItem.ref ?? '-',
        },
    });
}
/** Cely seznam v poradi, ve kterem ho brana vratila. */
export function formatAcceptanceMissingList(missing, locale) {
    return missing.map((entry) => formatAcceptanceMissing(entry, locale));
}
//# sourceMappingURL=acceptance-messages.js.map